module.exports = __webpack_public_path__ + "img/search-right.3064dfb6.svg";